/**
 * The Tiendanube storefront script draws the try-on button only for SKUs listed in
 * the merchant record (`availableSkus`), so that list has to follow the product's
 * NEW visibility: a product that is now shown publishes its SKUs, one that is now
 * hidden withdraws them.
 *
 * Callers pass the state the product is moving TO, not the one it is coming from.
 */
export const storefrontSkuDelta = (
  nowVisible: boolean,
  skus: string[]
): { added: string[]; removed: string[] } =>
  nowVisible ? { added: skus, removed: [] } : { added: [], removed: skus }
